import { type FC } from 'react'

import android from '@core/assets/v2/icons/brands/Icon-Android-Black.svg'
import androidWithBody from '@core/assets/v2/icons/brands/Icon-AndroidWithBody-Black.svg'
import apple from '@core/assets/v2/icons/brands/Icon-Apple-Black.svg'
import bankIDNorway from '@core/assets/v2/icons/brands/Icon-BankIDNorway-Black.svg'
import claude from '@core/assets/v2/icons/brands/Icon-Claude-Black.svg'
import facebook from '@core/assets/v2/icons/brands/Icon-Facebook-Black.svg'
import google from '@core/assets/v2/icons/brands/Icon-Google-Black.svg'
import instagram from '@core/assets/v2/icons/brands/Icon-Instagram-Black.svg'
import linkedIn from '@core/assets/v2/icons/brands/Icon-LinkedIn-Black.svg'
import whatsUp from '@core/assets/v2/icons/brands/Icon-WhatsUp-Black.svg'
import windows from '@core/assets/v2/icons/brands/Icon-Windows-Black.svg'
import x from '@core/assets/v2/icons/brands/Icon-X-Black.svg'
import youtube from '@core/assets/v2/icons/brands/Icon-Youtube-Black.svg'

import { createIcon } from './createIcon'
import type { BrandIconName, IconProps } from './types'

export const IconAndroid = createIcon(android, 'Android')
export const IconAndroidWithBody = createIcon(androidWithBody, 'AndroidWithBody')
export const IconApple = createIcon(apple, 'Apple')
export const IconBankIDNorway = createIcon(bankIDNorway, 'BankIDNorway')
export const IconClaude = createIcon(claude, 'Claude')
export const IconFacebook = createIcon(facebook, 'Facebook')
export const IconGoogle = createIcon(google, 'Google')
export const IconInstagram = createIcon(instagram, 'Instagram')
export const IconLinkedIn = createIcon(linkedIn, 'LinkedIn')
export const IconWhatsUp = createIcon(whatsUp, 'WhatsUp')
export const IconWindows = createIcon(windows, 'Windows')
export const IconX = createIcon(x, 'X')
export const IconYoutube = createIcon(youtube, 'Youtube')

export const brandIcons: Record<BrandIconName, FC<IconProps>> = {
    Android: IconAndroid,
    AndroidWithBody: IconAndroidWithBody,
    Apple: IconApple,
    BankIDNorway: IconBankIDNorway,
    Claude: IconClaude,
    Facebook: IconFacebook,
    Google: IconGoogle,
    Instagram: IconInstagram,
    LinkedIn: IconLinkedIn,
    WhatsUp: IconWhatsUp,
    Windows: IconWindows,
    X: IconX,
    Youtube: IconYoutube,
}
